<template>
  <div>
    <div id="footer">
      <div class="footer_1">
        <div class="footer_1_left">
          <div class="title">白天精力好 晚上睡得香</div>
          <div class="subtitle">{{ company.definition }}</div>
        </div>
        <div class="footer_1_right">
          <a
            :href="purchase.tmallFullUrl"
            target="_blank"
            rel="noopener noreferrer"
            ><button type="button">前往天猫官方旗舰店</button></a
          >
        </div>
      </div>
      <div class="divider"></div>
      <div class="footer_2">
        <div class="footer_2_left">
          <div>
            <p>产品中心</p>
            <ul>
              <li>
                <router-link to="/lotus2device">LOTUS 2 能量版</router-link>
              </li>
              <li>
                <router-link to="/lotus2Rdevice">LOTUS 2R 认知版</router-link>
              </li>
              <li>
                <router-link to="/sleep">Lume 光能睡眠仪</router-link>
              </li>
              <li>
                <router-link to="/products">产品对比</router-link>
              </li>
            </ul>
          </div>
          <div>
            <p>品牌与科学</p>
            <ul>
              <li>
                <router-link to="/science">科学与研究</router-link>
              </li>
              <li>
                <router-link to="/mood">技术原理</router-link>
              </li>
            </ul>
          </div>
          <div>
            <p>关于我们</p>
            <ul>
              <li>
                <router-link to="/home">创始人与团队</router-link>
              </li>
              <li>
                <router-link to="/news">新闻与报道</router-link>
              </li>
            </ul>
          </div>
          <div>
            <p>支持</p>
            <ul>
              <li>
                <router-link to="/support">常见问题</router-link>
              </li>
              <li>
                <router-link to="/buy">购买指引与防伪</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer_2_right">
          <div class="email">
            <div class="email_content">
              <div class="email_copy">
                <div id="email_num">{{ contact.phone }}</div>
                <img src="../../assets/icon_Copy.png" @click="copyEmail()" />
              </div>
            </div>
          </div>
          <div class="weChat">
            <div class="wechat_content">
              <img src="../../assets/wechat_qrcode.png" />
              <div>扫码关注微信公众号：{{ contact.wechatName }}</div>
            </div>
          </div>
          <a :href="contact.weibo">
            <div class="weBo"></div>
          </a>
          <div class="tiktok">
            <div class="tiktok_content">
              <img src="../../assets/QR_tiktok.png" />
              <div>扫码关注抖音号：{{ contact.douyinName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_3">
        <div>
          版权所有{{ company.fullName }} ©Copyright 2019-{{ year }}. All Rights
          Reserved.
        </div>
        <div>
          <a :href="company.icpLink" target="_blank" rel="noopener">{{
            company.icp
          }}</a>
          <span class="sep">|</span>
          NMPA 二类医疗器械注册证：{{ company.nmpaCertNo }}
          <span class="sep">|</span>
          官方店铺：天猫「{{ purchase.tmallStoreName }}」
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { company, purchase, contact } from "@/data/facts";

export default {
  data() {
    return {
      year: "",
      company,
      purchase,
      contact,
    };
  },
  mounted() {
    this.getYear();
  },
  methods: {
    toguid(path) {
      this.$router.push(path);
    },
    copyEmail() {
      var email = document.getElementById("email_num").innerText;
      var oInput = document.createElement("input");
      oInput.value = email;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("copy");
      oInput.className = "oInput";
      oInput.style.display = "none";
      alert("复制成功");
    },
    getYear() {
      const time = new Date();
      this.year = time.getFullYear();
    },
  },
};
</script>
<style scoped>
#footer {
  width: 100vw;
  height: auto;
  padding-bottom: 2.4vw;
  background: #1b1e8a;
  position: relative;
}

.footer_1 {
  overflow: hidden;
  margin: 0 13.3vw;
}

.footer_1_left {
  float: left;
  margin-top: 7.8vw;
}

.footer_1_right {
  float: right;
  margin-top: 7.8vw;
}

.title {
  font-family: "SourceHanSansCN-Bold";
  font-weight: bold;
  font-size: 2.5vw;
  color: #ffffff;
}

.subtitle {
  width: 48vw;
  margin-top: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  font-size: 0.78vw;
  line-height: 1.8;
  color: #ffffff;
}

.footer_1_right button {
  width: 10.2vw;
  height: 3.1vw;
  border-radius: 0.3vw;
  background-color: #888ef9;
  color: #ffffff;
  border: none;
  font-size: 0.8vw;
  margin-top: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  cursor: pointer;
}

.divider {
  border-top: 0.05vw solid #ffffff;
  margin: 3.4vw 13.3vw 2.6vw 13.3vw;
}

.footer_2 {
  position: relative;
  margin-left: 13.3vw;
}

.footer_2_left div {
  display: inline-block;
  vertical-align: top;
  color: #ffffff;
  margin-right: 7.3vw;
}

.footer_2_left p {
  font-weight: 500;
  font-family: "SourceHanSansCN-Medium";
  font-size: 0.9vw;
  margin-bottom: 1.1vw;
}

ul {
  margin: 0;
  padding: 0;
}

ul > li {
  list-style-type: none;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  font-size: 0.8vw;
  cursor: pointer;
}

ul > li a {
  color: #ffffff;
}

.footer_2_right {
  position: absolute;
  right: 13.3vw;
  top: 0;
}

.footer_2_right .email,
.footer_2_right .weChat,
.footer_2_right .weBo,
.footer_2_right .tiktok {
  width: 2.2vw;
  height: 2.2vw;
  display: inline-block;
  margin-left: 0.45vw;
  position: relative;
}

.email {
  background: url(../../assets/phone.png) no-repeat;
  background-size: 100% 100%;
}

.email:hover,
.email:active,
.email:focus {
  background: url(../../assets/phone.png) no-repeat;
  background-size: 100% 100%;
}

.weChat {
  background: url(../../assets/WeChat.png) no-repeat;
  background-size: 100% 100%;
}

.weChat:hover,
.weChat:active,
.weChat:focus {
  background: url(../../assets/WeChat-purple.png) no-repeat;
  background-size: 100% 100%;
}

.weBo {
  background: url(../../assets/Webo.png) no-repeat;
  background-size: 100% 100%;
}

.weBo:hover,
.weBo:active,
.weBo:focus {
  background: url(../../assets/Webo-purple.png) no-repeat;
  background-size: 100% 100%;
}

.tiktok {
  background: url(../../assets/tiktok.png) no-repeat;
  background-size: 100% 100%;
}

.tiktok:hover,
.tiktok:active,
.tiktok:focus {
  background: url(../../assets/tiktok-purple.png) no-repeat;
  background-size: 100% 100%;
}

.email .email_content,
.weChat .wechat_content,
.tiktok .tiktok_content {
  visibility: hidden;
}

.email:hover .email_content,
.email:active .email_content,
.email:focus .email_content,
.weChat:hover .wechat_content,
.weChat:active .wechat_content,
.weChat:focus .wechat_content,
.tiktok:hover .tiktok_content,
.tiktok:active .tiktok_content,
.tiktok:focus .tiktok_content {
  visibility: visible;
}

.email_content {
  position: absolute;
  top: 3.4vw;
  width: 18.75vw;
  height: 2.92vw;
  background: #ffffff;
  box-shadow: 0px 2px 8px 2px rgba(0, 0, 0, 0.32);
}

.email_copy {
  margin: 0 1.25vw;
  position: relative;
}

.email_copy div {
  color: #333333;
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  line-height: 2.92vw;
}

.email_copy img {
  width: 1.25vw;
  height: 1.25vw;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.wechat_content,
.tiktok_content {
  position: absolute;
  top: 3.4vw;
}

.wechat_content img,
.tiktok_content img {
  width: 9.4vw;
  height: 11.9vw;
}

.wechat_content div,
.tiktok_content div {
  font-size: 0.9vw;
  font-weight: 400;
  font-family: "SourceHanSansCN-Normal";
  color: #333333;
  text-align: center;
  margin: -3.7vw 0.8vw 0 0.8vw;
}

.footer_3 {
  width: 90vw;
  color: #ffffff;
  font-size: 0.78vw;
  margin: 3.2vw auto 0;
  font-weight: 400;
  font-family: "SourceHanSansCN-Regular";
  opacity: 0.5;
  text-align: center;
  line-height: 1.9;
}

.footer_3 a {
  color: inherit;
}

.footer_3 .sep {
  margin: 0 0.8vw;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FooterInfo.vue